import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { Button, ButtonVariants } from '../../shared/Button';
import { ModalBoxStyled, TermsPage } from './CustomTerms.styled';

export const PreCustomGDPR = ({ onApply, onNotApply }) => {
  const { t } = useTranslation();
  const buttonRefNext = React.createRef();

  const { register, handleSubmit } = useForm();

  const onSubmit = (data) => {
    if (data['eu-resident'] === 'true' || data['eu-citizen'] === 'true') {
      onApply();
    } else {
      onNotApply();
    }
  };

  return (
    <TermsPage withBackground>
      <ModalBoxStyled>
        <form className="!block" onSubmit={handleSubmit(onSubmit)}>
          <div className="space-y-8">
            <div>
              <div className="mb-3">1. Avrupa Birliği vatandaşı mısınız?</div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <input
                    {...register('eu-citizen', { required: true })}
                    required
                    name="eu-citizen"
                    type="radio"
                    id="eu-citizen-true"
                    value="true"
                  />
                  <label htmlFor="eu-citizen-true">Evet</label>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    {...register('eu-citizen', { required: true })}
                    required
                    name="eu-citizen"
                    type="radio"
                    id="eu-citizen-false"
                    value="false"
                  />
                  <label htmlFor="eu-citizen-false">Hayır</label>
                </div>
              </div>
            </div>
            <div>
              <div className="mb-3">2. Avrupa Birliği sınırları içinde ikamet ediyor musunuz?</div>
              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <input
                    {...register('eu-resident', { required: true })}
                    required
                    name="eu-resident"
                    type="radio"
                    id="eu-resident-true"
                    value="true"
                  />
                  <label htmlFor="eu-resident-true">Evet</label>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    {...register('eu-resident', { required: true })}
                    required
                    name="eu-resident"
                    type="radio"
                    id="eu-resident-false"
                    value="false"
                  />
                  <label htmlFor="eu-resident-false">Hayır</label>
                </div>
              </div>
            </div>
          </div>
          <Button className="!mt-8 !w-full" ref={buttonRefNext} variant={ButtonVariants.PRIMARY} type="submit">
            {t('Devam Et')}
          </Button>
        </form>
      </ModalBoxStyled>
    </TermsPage>
  );
};
